import React from 'react';
import '../../styles/ServicePicker.css';

function formatDuration(dur) {
  if (!dur) return '';
  const h = Math.floor(dur / 60);
  const m = dur % 60;
  if (h === 0) return `${m} دقيقة`;
  if (m === 0) return h === 1 ? 'ساعة' : h === 2 ? 'ساعتين' : `${h} ساعات`;
  return `${h}:${String(m).padStart(2, '0')}`;
}

function ServicePicker({ reservationTypes, selectedType, onSelect }) {
  if (!reservationTypes.length) {
    return <p className="service-picker-empty">لا توجد أنواع حجز متاحة حالياً.</p>;
  }

  return (
    <section className="service-picker">
      <h2 className="section-title">اختر نوع الحجز</h2>
      <div className="service-picker-list">
        {reservationTypes.map((rt) => {
          const isSelected = selectedType?.id === rt.id;
          return (
            <button
              key={rt.id}
              type="button"
              className={`service-picker-item ${isSelected ? 'selected' : ''}`}
              onClick={() => onSelect(rt)}
            >
              <div className="service-picker-item-info">
                <span className="service-picker-name">{rt.name}</span>
                <span className="service-picker-meta">
                  {rt.price != null && <span className="service-picker-price">₪{Number(rt.price)}</span>}
                  {rt.duration_minutes && (
                    <span className="service-picker-duration">{formatDuration(rt.duration_minutes)}</span>
                  )}
                </span>
              </div>
              <span className="service-picker-check" aria-hidden="true">
                {isSelected ? '✓' : ''}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default ServicePicker;
